var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.57 3H11.88C9.8 3 8.5 4.3 8.5 6.38V9.0125H12.5625C12.829 9.0125 13.05 9.2335 13.05 9.5C13.05 9.7665 12.829 9.9875 12.5625 9.9875H8.5V12.62C8.5 14.7 9.8 16 11.88 16H13.5635C15.6435 16 16.9435 14.7 16.9435 12.62V6.38C16.95 4.3 15.65 3 13.57 3Z",
    fill: "#FA4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5604 9.0424L6.82337 7.77944C6.91489 7.68792 6.9576 7.57199 6.9576 7.45607C6.9576 7.34015 6.91489 7.21812 6.82337 7.1327C6.64643 6.95577 6.35357 6.95577 6.17663 7.1327L4.1327 9.17663C3.95577 9.35357 3.95577 9.64643 4.1327 9.82337L6.17663 11.8673C6.35357 12.0442 6.64643 12.0442 6.82337 11.8673C7.0003 11.6904 7.0003 11.3975 6.82337 11.2206L5.5604 9.9576H8.26937V9.0424H5.5604Z",
    fill: "#FA4747"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.eab1fe4ff59a61d4829dff3ab7d3b99a.svg";
export { ForwardRef as ReactComponent };